import {useAppSelector} from 'store/hooks';
import {
  selectMetadataEditEditStatuses,
  selectMetadataEditStatuses,
} from '../metadataEditSlice';

export const useMetadataHasChanges = (): boolean => {
  return useAppSelector(state => {
    const editStatuses = selectMetadataEditEditStatuses(state);
    const statuses = selectMetadataEditStatuses(state);

    return (
      Object.keys(editStatuses).some(
        id => editStatuses[id].hasDataChanged || editStatuses[id].hasMoved,
      ) || Object.keys(statuses).some(id => statuses[id].changedStatus)
    );
  });
};
